import { render, staticRenderFns } from "./DealWonConfirmModal.vue?vue&type=template&id=70c0ddbc&"
import script from "./DealWonConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DealWonConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports